'use strict';

/**
 * 采集页面性能点信息
 * 
 * @param {PageManager} pageManager
 */
module.exports = function initCatch(pageManager) {
    var cfgManager = pageManager.cfgManager;

    if (cfgManager.get('autoCatch').page && !pageManager.getReady()) {

        if (document && document.readyState === 'complete') {
            pageManager.parsePageTimeWithDefer();
        } else {
            var ADD_EVENT = window.addEventListener || window.attachEvent;

            ADD_EVENT('load', function () {
                pageManager.parsePageTimeWithDefer();
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/owl/lib/page/catch.js
// module id = 250
// module chunks = 0